<template>
    <div>
        <el-container class="mainInfo" v-loading="mainLoading">
            <el-main>
                    <toolBar :loading.sync="mainLoading"
                             :menuId="menu_id"
                             :searchData="searchData"
                             @search="search"
                             @excel="excel">
                    </toolBar>

                <el-table
                        show-summary
                        :summary-method="getSummaries"
                        ref="table"
                        :data="dataList"
                        height="400"
                        style="width: 100%;"
                        highlight-current-row
                        :header-cell-style="headerStyle"
                        :cell-style="cellStyle"
                        row-key="id"
                        border>
                    <el-table-column
                            type="index"
                            :index="(pageInfo.page-1) * pageInfo.pagesize+1"
                            label="序号"
                            align="center"
                            width="50">
                    </el-table-column>
                    <el-table-column
                            prop="typeName"
                            label="物资分类"
                            align="center"
                            width="100">
                    </el-table-column>
                    <el-table-column
                            prop="startNum"
                            label="期初数量"
                            align="center"
                            width="150">
                    </el-table-column>
                    <el-table-column
                            prop="startPrice"
                            label="期初单价"
                            align="center"
                            width="150">
                        <template slot-scope="scope">
                            {{ getPrecisionData(scope.row.avgPrice)}}
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="startTotal"
                            label="期初金额"
                            align="center"
                            width="150">
                    </el-table-column>
                    <el-table-column
                            prop="intoNum"
                            label="入库数量"
                            align="center"
                            width="150">
                    </el-table-column>
                    <el-table-column
                            prop="intoPrice"
                            label="入库单价"
                            align="center"
                            width="150">
                        <template slot-scope="scope">
                            {{ getPrecisionData(scope.row.intoPrice)}}
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="intoTotal"
                            label="入库金额"
                            align="center"
                            width="150">
                    </el-table-column>
                    <el-table-column
                            prop="outNum"
                            label="出库数量"
                            align="center"
                            width="150">
                    </el-table-column>
                    <el-table-column
                            prop="outPrice"
                            label="出库单价"
                            align="center"
                            width="150">
                        <template slot-scope="scope">
                            {{ getPrecisionData(scope.row.outPrice)}}
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="outTotal"
                            label="出库金额"
                            align="center"
                            width="150">
                    </el-table-column>
                    <el-table-column
                            prop="lossNum"
                            label="损益数量"
                            align="center"
                            width="150">
                    </el-table-column>
                    <el-table-column
                            prop="lossTotal"
                            label="损益金额"
                            align="center"
                            width="150">
                    </el-table-column>
                    <el-table-column
                            prop="endNum"
                            label="期末数量"
                            align="center"
                            width="150">
                    </el-table-column>
                    <el-table-column
                            prop="endPrice"
                            label="期末单价"
                            align="center"
                            width="150">
                        <template slot-scope="scope">
                            {{ getPrecisionData(scope.row.endPrice)}}
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="endTotal"
                            label="期末金额"
                            align="center"
                            width="150">
                    </el-table-column>
                </el-table>
                <div class="pagStyle">
                    <pagination :pageInfo="pageInfo" @toPage="toPage"></pagination>
                </div>
            </el-main>
        </el-container>
    </div>
</template>

<script>
    import toolBar from '@/components/page/statistics/productbytype/toolBar'
    import pagination from "@/components/tools/table/pagination";

    export default {
        name: "productbytype",
        props: ['menuData'],
        components: {pagination, toolBar},
        data() {
            return {
                sumObject:{},
                mainLoading: false,
                menu_id: this.menuData.menuId,
                searchData: {
                    formData:{}
                },

                width: "350px",
                dialogLoading: false,
                formData: {},
                tableH: 100,
                dataList: [],
                loading: false,
                pageInfo: {
                    page: 1,
                    pagesize: 20,
                    pageSizes: [10, 20, 50, 100],
                    total: 0,
                }
            }
        },
        updated () {
            this.$nextTick(() => {
                this.$refs.table.doLayout(); //解决表格错位
            });
        },
        methods: {
            async getListData() {

                this.loading = true;
                let param = {
                    url: "/statisticsproduct/listProductByType",
                    param: {
                        ...this.searchData.formData,
                        limit: this.pageInfo.pagesize,
                        page: this.pageInfo.page
                    }
                }
                const data = await this.$store.dispatch('pubMethod', param)
                if (data.infoCode == "0") {
                    this.dataList = data.data.jsonObject.data;
                    this.sumObject = data.data.sumObject;
                    this.pageInfo.total = data.data.jsonObject.count;
                }
                this.loading = false;
            },
            getPrecisionData(value){
                if(value!=undefined && value!=null &&value!='') {
                    return this.$pub.getPrecisionData(Number(value), this.precisionPrice)
                }
            },
            toPage() {
                this.getListData();
            },
            search(data) {
                this.searchData.formData = data;
                this.pageInfo.page = 1;
                this.getListData();
            },
            excel(data) {
                this.searchData.formData = data;

                let param = {
                    url: "/statisticsproduct/excelProductByType",
                    param: {
                        ...this.searchData.formData,
                        limit: this.pageInfo.pagesize,
                        page: this.pageInfo.page
                    }
                }

                this.$pub.openPostWindow(param);
            },
            headerStyle() {
                return "text-align:center;height:35px;line-height:35px;padding: 5px 0;background-color:#f2f2f2;border-left:1px solid #e5e6e8;border-top:1px solid #e5e6e8;border-bottom:1px solid #e5e6e8"
            },
            cellStyle() {
                return "text-align:center"
            },
            tableOpt() {
            },
            getSummaries(param) {
                const { columns, data } = param;
                const sums = [];
                columns.forEach((column, index) => {
                    if (index === 0) {
                        sums[index] = '合计';
                        return;
                    }
                    //const values = data.map(item => Number(item[column.property]));
                    let field=column.property;
                    switch (field) {
                        case "startNum":
                            sums[index]=this.sumObject.startNum;
                            break;
                        case "startTotal":
                            sums[index]=this.sumObject.startTotal;
                            break;
                        case "intoNum":
                            sums[index]=this.sumObject.intoNum;
                            break;
                        case "intoTotal":
                            sums[index]=this.sumObject.intoTotal;
                            break;
                        case "outNum":
                            sums[index]=this.sumObject.outNum;
                            break;
                        case "outTotal":
                            sums[index]=this.sumObject.outTotal;
                            break;
                        case "lossNum":
                            sums[index]=this.sumObject.lossNum;
                            break;
                        case "lossTotal":
                            sums[index]=this.sumObject.lossTotal;
                            break;
                        case "endNum":
                            sums[index]=this.sumObject.endNum;
                            break;
                        case "endTotal":
                            sums[index]=this.sumObject.endTotal;
                            break;
                    }
                });

                return sums;
            },
        }
    }
</script>
